/* special thx to the homiez at 
https://github.com/championswimmer/vuex-module-decorators
https://github.com/garyo/vuex-module-decorators-example/tree/4164d9bfd01f7be10b0c89b446eea94c828e570d
*/

import Vue from "vue";
import Vuex, { Store } from "vuex";
import { initializeStores, modules } from "./store-accessor";
import VuexReset from "@ianwalter/vuex-reset";
import { vuexUndoPluginInitFunction } from "../lib/undo/undo";

Vue.use(Vuex);

const initializer = (store: Store<any>) => initializeStores(store);
export const plugins = [initializer];
export * from "./store-accessor";

export default new Store({
  strict: false,
  // strict: process.env.NODE_ENV !== "production"
  // i can't remember a single time when this has saved my ass. famous last words lol.
  // https://vuex.vuejs.org/guide/strict.html
  plugins: [...plugins, VuexReset(), vuexUndoPluginInitFunction],
  modules
});
